import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "text-area-value" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "col" };
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_td = _resolveComponent("q-td");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_file_preview = _resolveComponent("file-preview");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.props.row.isDeleted)
            ? (_openBlock(), _createBlock(_component_q_tr, { key: 0 }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.row.bukkenName), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.row.roomNumber), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.row.nyukyosha), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.row.taikyoYmd), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.row.kaiyakuYmd == null ? "" : _ctx.dayjs(_ctx.props.row.kaiyakuYmd ?? "").format("YYYY/MM/DD")), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.taikyoReasons.find(x => x.value === _ctx.props.row.taikyoRiyuKb)?.label), 1)
                        ]),
                        _: 1
                    }),
                    (_ctx.props.columns.some(x => x.name === 'taikyoRiyu' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 0,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.taikyoRiyu), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'sonotaKeiyaku' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 1,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.props.row.sonotaKeiyaku), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_q_td, { class: "text-left" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.contactKbList.find(x => x.value === _ctx.props.row.renrakuKb)?.label), 1)
                        ]),
                        _: 1
                    }),
                    (_ctx.props.columns.some(x => x.name === 'renrakuName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 2,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.renrakuName), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'renrakuRelationship' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 3,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.renrakuRelationship), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'tel' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 4,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.tel), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'email' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 5,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.email), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'keyReturnYmd' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 6,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.keyReturnYmd), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'numberOfReturnKeys' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 7,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.numberOfReturnKeys), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'shopName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 8,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.props.row.shopName), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'selectedTachiaishaKbn' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 9,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.tachiaishaKbnList.find(x => x.value === _ctx.props.row.taikyoTachiaiKb)?.label), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'taikyoTachiaiName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 10,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.taikyoTachiaiName), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'keyReturnAdrKb' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 11,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.contactKbList.find(x => x.value === _ctx.props.row.keyReturnAdrKb)?.label), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'soufuName' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 12,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.soufuName), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'postCode' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 13,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.postCode), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr1' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 14,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.adr1), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr2' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 15,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.adr2), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'adr3' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 16,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.adr3), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'soufuSonota' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 17,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.soufuSonota), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'hasonFile' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 18,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false), (file) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: file.fileId,
                                            class: "row items-center q-gutter-sm"
                                        }, [
                                            _createElementVNode("span", {
                                                class: "text-blue cursor-pointer underline-link",
                                                onClick: ($event) => (_ctx.openHasonPreview(file.fileId))
                                            }, _toDisplayString(file.fileName), 9, _hoisted_4)
                                        ]));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.props.columns.some(x => x.name === 'otherFile' && x.visible === true))
                        ? (_openBlock(), _createBlock(_component_q_td, {
                            key: 19,
                            class: "text-left"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false), (file) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: file.fileId,
                                            class: "row items-center q-gutter-sm"
                                        }, [
                                            _createElementVNode("span", {
                                                class: "text-blue cursor-pointer underline-link",
                                                onClick: ($event) => (_ctx.openOtherPreview(file.fileId))
                                            }, _toDisplayString(file.fileName), 9, _hoisted_6)
                                        ]));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        (_ctx.visibleHasonFileDialog)
            ? (_openBlock(), _createBlock(_component_file_preview, {
                key: 1,
                fileCode: _ctx.FileCode.TaikyoHasonFile,
                targetNo: _ctx.props.row.taikyoNo,
                index: _ctx.selectedIndex,
                result: _ctx.props.result,
                fileInfo: _ctx.props.fileInfo,
                onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.visibleHasonFileDialog = false))
            }, null, 8, ["fileCode", "targetNo", "index", "result", "fileInfo"]))
            : _createCommentVNode("", true),
        (_ctx.visibleOtherFileDialog)
            ? (_openBlock(), _createBlock(_component_file_preview, {
                key: 2,
                fileCode: _ctx.FileCode.TaikyoOthersFile,
                targetNo: _ctx.props.row.taikyoNo,
                index: _ctx.selectedIndex,
                result: _ctx.props.result,
                fileInfo: _ctx.props.fileInfo,
                onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.visibleOtherFileDialog = false))
            }, null, 8, ["fileCode", "targetNo", "index", "result", "fileInfo"]))
            : _createCommentVNode("", true)
    ], 64));
}
